import './InlineLabel.9d6551bcda520014b24a71c625a60a6e.css';
export default {"inlineLabel":"_inlineLabel_kocn5_1"};